import { Type, Transform } from 'class-transformer'
import { DateTime, Duration } from 'luxon'
import { NurseTier, PaymentOption, Role } from 'types/types'
import { PAYMENT_OPTION_TO_PAYMENT_SCHEDULE_MAPPING } from 'types/constants'

export default class AvailabilityCheck {
    id!: number
    
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    start_at!: DateTime
    
    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    end_at!: DateTime

    @Type(() => Duration)
    @Transform(({ value }) => Duration.fromMillis(1000 * Number(value)))
    lunch_break!: Duration

    postcode!: string
    lat!: number
    lng!: number
    practice_name!: string
    payment_option!: PaymentOption
    settlement_days!: number
    role!: Role
    tiers!: NurseTier[]
    sedation_required!: boolean
    radiography_required!: boolean
    implant_required!: boolean
    orthodontics_required!: boolean

    @Type(() => DateTime)
    @Transform(({ value }) => DateTime.fromISO(value))
    created_at!: DateTime

    lead_id!: number | null
    job_employment_id!: number | null

    // annotated recommended nurse
    recommended_nurse_id!: number | null | undefined
    recommended_nurse_reason!: string

    // annotate is_expired
    is_expired!: boolean

    // annotate num_results
    num_available!: number
    num_unavailable!: number
    num_pending!: number

    get numTotal() {
        return this.num_available + this.num_unavailable + this.num_pending
    }

    get isNurseFound() {
        return this.recommended_nurse_id !== null && this.recommended_nurse_id !== undefined
    }

    get isBookingConfirmed() {
        return this.job_employment_id !== null && this.job_employment_id !== undefined
    }

    dateLabel(tz: string = 'Europe/London') {
        return this.start_at.setZone(tz).toFormat('dd MMM yyyy')
    }

    timeLabel(tz: string = 'Europe/London') {
        return this.start_at.setZone(tz).toFormat('hh:mm a') + ' - ' + this.end_at.setZone(tz).toFormat('hh:mm a')
    }

    get statusLabel() {
        if (this.is_expired) {
            return 'Date Passed'
        } else if (this.isBookingConfirmed) {
            return 'Confirmed'
        } else if (this.isNurseFound) {
            return 'Nurse Found'
        } else {
            return 'Searching'
        }
    }

    get paymentScheduleLabel() {
        return PAYMENT_OPTION_TO_PAYMENT_SCHEDULE_MAPPING[this.payment_option]?.['practice'] ?? 'N/A'
    }

    get lunchBreakLabel() {
        return `${this.lunch_break.as('minutes')} minutes`
    }

    get statusColor() {
        if (this.is_expired) {
            return 'default'
        } else if (this.isBookingConfirmed) {
            return 'primary'
        } else if (this.isNurseFound) {
            return 'success'
        } else {
            return 'primary'
        }
    }
}